import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en.json';
import ro from './locales/ro.json';
import enOps from './locales/ext/operations.en.json';
import roOps from './locales/ext/operations.ro.json';

/**
 * English is the source language and fallback; Romanian ships in phase one (user decision U2). The operations modules
 * (AFM requirements) keep their texts in locales/ext/operations.*.json, merged over the base catalogue.
 */
export const LOCALES = ['en', 'ro'] as const;
export type Locale = (typeof LOCALES)[number];

declare module 'i18next' {
  interface CustomTypeOptions {
    defaultNS: 'translation';
    resources: { translation: typeof en & typeof enOps };
  }
}

type Tree = { [k: string]: string | Tree };

/** Deep merge of translation trees (the operations modules extend existing sections such as `nav` or `roles`). */
export function mergeTree(a: Tree, b: Tree): Tree {
  const out: Tree = { ...a };
  for (const [k, v] of Object.entries(b)) {
    const cur = out[k];
    out[k] = typeof v === 'object' && typeof cur === 'object' ? mergeTree(cur, v) : v;
  }
  return out;
}

export function initI18n(locale: Locale) {
  void i18n.use(initReactI18next).init({
    resources: {
      en: { translation: mergeTree(en as Tree, enOps as Tree) },
      ro: { translation: mergeTree(ro as Tree, roOps as Tree) },
    },
    lng: locale,
    fallbackLng: 'en',
    interpolation: { escapeValue: false },
    returnNull: false,
  });
  document.documentElement.lang = locale;
  return i18n;
}

export { i18n };
